import { FC,  useContext, } from "react";
import Term from "components/term";
import SelectMultiple from '../../../../components/select-multiple';
import { FormControl, InputLabel, makeStyles, useTheme, TextField } from "@material-ui/core";
import { FiltersContext } from "./filters.context";
import { FilterDataContext } from "./filter.data.context";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    formControl: {
        margin: `30px 0`,
        [theme.breakpoints.up('md')]: {
            margin: `10px 5px`,
        }
    },
    group: {
        margin: `10px 0`,
    },
    block: {
        display: `inline-block`
    },
    hidden: {
        display: `none`
    },
    middle: {
        verticalAlign: `middle`
    },
}));

export type ScreenType = 'domiciliaciones' |  'cartero-virtual-pendiente' | 'cartero-virtual-pagado' | 'tributos-autonomicos' | 'domiciliados' | 'pago-carta';

export interface IFiltersFormProps {
}

const FiltersForm: FC<IFiltersFormProps> = ()=> {
    
    const [filters, filtersDispatch] = useContext(FiltersContext);
    const filterData = useContext(FilterDataContext);
  
    const handleMunicipioChange = (municipio: string[]) => filtersDispatch({ type: 'update', filter: 'organismos', value: municipio });
    const handleObjTributario = (objTributario: string) => filtersDispatch({ type: 'update', filter: 'objTributario', value: objTributario });
    const handleDirTributaria = (dirTributaria: string) => filtersDispatch({ type: 'update', filter: 'dirTributaria', value: dirTributaria });
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <div className={classes.root}>
                <FormControl key='organismo' className={filterData && filterData.organismos ? classes.formControl : classes.hidden} fullWidth>
                    <InputLabel key='label-organismo' htmlFor="select-multiple-chip">
                        <Term component="Global" text="Municipio / Organismo" />
                    </InputLabel>
                    <SelectMultiple
                        key='organismos'
                        options={filterData && filterData.organismos ? filterData.organismos : []} value={filters.organismos || []}
                        onChange={(values: any) => handleMunicipioChange(values)}
                    />
                </FormControl>
                <FormControl key="objTributario" className={classes.formControl} fullWidth>
                    <TextField
                        key="objTributario"
                        value={filters.objTributario || ""}
                        label={<Term component="CarteroVirtual" text="Objeto Tributario" />}
                        onChange={(evt) => handleObjTributario(evt.target.value)}
                    />
                </FormControl>
                <FormControl key="dirTributaria" className={classes.formControl} fullWidth>
                        <TextField
                            key="dirTributaria"
                            value={filters.dirTributaria || ""}
                            label={<Term component="CarteroVirtual" text="Dirección Tributaria" />}
                            onChange={(evt) => handleDirTributaria(evt.target.value)}
                        />
                </FormControl>
                
        </div>
    );
}

export default FiltersForm;